
















































































































































































































































































































































































































































































































































































import Vue from 'vue';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubButton,
  HubCard,
  HubCheckbox,
  HubHeading,
  HubIcon,
  HubInput,
  HubModal,
  HubSelect,
  HubSwitch,
  HubTextarea,
} from '@/components/HubComponents';
import {
  LiveSocialCard,
  LiveSocialChat,
  ModalTechicalInfo,
  LiveSocialDownloadButton,
  LiveSocialGoogleButton,
} from '@/components/LiveSocial';
import { ViewLiveSocial } from '../typings/views';

export default Vue.extend({
  name: 'ViewLiveSocial' as string,

  components: {
    AppHeader,
    HubButton,
    HubCard,
    HubCheckbox,
    HubHeading,
    HubIcon,
    HubInput,
    HubModal,
    HubSelect,
    HubSwitch,
    HubTextarea,
    LiveSocialCard,
    LiveSocialChat,
    ModalTechicalInfo,
    LiveSocialDownloadButton,
    LiveSocialGoogleButton,
  },

  props: {
    hash: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      broadcastModalMessage: '',
      showModal: {
        custom: false,
        instagram: false,
        twitch: false,
        youtube: false,
      },
      twitchLiveModalForm: {
        name: '',
        streamUrl: '',
        streamKey: '',
      },
      twitchServers: [{
        text: 'South America: Rio de Janeiro, Brazil',
        value: 'rtmp://live-rio.twitch.tv/app',
      }, {
        text: 'South America: Sao Paulo, Brazil',
        value: 'rtmp://live-sao.twitch.tv/app',
      }],
      madeForKids: false,
      selectedPrivacyStatus: 'public',
      customerPlanData: {} as Services.User.Response.CustomerPlan,
      customServiceName: '',
      hasModalStartStopBroadcastBeenCancelled: false,
      hasModalStartStopBroadcastBeenConfirmed: false,
      haveAllCardsBeenMounted: false,
      infoModal: false,
      isMaxNumberOfSelectedServices: false,
      isModalStartStopBroadcastButtonLoading: false,
      isSaveLiveSocialGeneralButtonLoading: false,
      isSaveOrUpdateCustomAccountButtonLoading: false,
      isStartStopRetransmissionButtonLoading: false,
      isSaveOrUpdateTwitchLiveLoading: false,
      isStreamSoftwareStarted: false,
      isUpdatingService: false,
      lastSelectedService: {} as Store.LiveSocial.LiveSocialNetwork,
      menuButtons: [
        {
          icon: 'calendar-month-outline',
          label: this.$t('event'),
          href: `/event/${this.hash}`,
        },
        {
          icon: 'play',
          label: 'Player',
          href: `/player/${this.hash}`,
        },
        {
          icon: 'broadcast',
          label: 'Live Social',
          href: `/live-social/${this.hash}`,
        },
        {
          icon: 'chart-bar',
          label: this.$t('statistics'),
          href: `/statistics/${this.hash}`,
        },
      ],
      modalCreateLiveSocial: false,
      modalStartStopBroadcast: false,
      rules: {
        required: (value: string) => !!value.trim() || this.$t('required_field'),
      },
      selectAll: false,
      // selectedCategory: '',
      serviceToBeEdited: null as (null | Store.LiveSocial.LiveSocialNetwork),
      simultaneousLivesLimit: 3,
      socialNetworks: [
        {
          provider: 'facebook',
          link: `${process.env.VUE_APP_FACEBOOK_API}/api/auth`
            .concat(`?redirect_url=${window.location.origin}/callback/facebook`)
            .concat(`?hash=${this.hash}`),
        },
        {
          provider: 'youtube',
          link: 'https://accounts.google.com/o/oauth2/auth'
            .concat(`?client_id=${process.env.VUE_APP_YOUTUBE_API_CLIENT_ID}`)
            .concat(`&redirect_uri=${window.location.origin}/callback/youtube`)
            .concat(`&scope=${[
              'https://www.googleapis.com/auth/youtube'
                .concat(' https://www.googleapis.com/auth/youtube.force-ssl')
                .concat(' https://www.googleapis.com/auth/userinfo.email'),
            ]}`)
            .concat('&access_type=offline&include_granted_scopes=true&response_type=code')
            .concat(`&state=${btoa(`${window.location.origin}/live-social/${this.hash}`)}`),
          disabled: false,
        },
        { provider: 'twitch' },
        { provider: 'instagram' },
        { provider: 'custom' },

      ] as ViewLiveSocial.SocialNetwork[],
      streamServiceAccessKey: '',
      streamServiceUrl: '',
      // tags: '',
      typedDescription: '',
      typedTitle: '',
      warningMessage: '',
      warningModal: false,
    };
  },

  computed: {
    ...mapGetters('liveSocial', ['createdServices', 'isThereAtLeastOneBroadcastingWay']),
    ...mapState(['events', 'liveSocial', 'user']),
    activeServices(): Store.LiveSocial.LiveSocialNetwork[] {
      return this.createdServices.filter((service: Store.LiveSocial.LiveSocialNetwork) => (
        service.status
      ));
    },
    allConnectedAccounts(): ViewLiveSocial.ConnectedAccount[] {
      // Primeiro ordena os providers para serem exibidos na ordem que está
      // configurado os providers no array "socialNetworks".
      // Depois filtra os providers que tem alguma conta conectada.
      // E por fim, mapeia estes providers de forma que este computed retorne
      // todos as contas conectadas, no formato:
      // [{
      //   provider: nome do provider,
      //   indexProvider: índice da conta no array do provider armazenado na store
      // }]
      return this.socialNetworks.map((socialNetwork) => {
        const providerKey = socialNetwork.provider;

        return [
          socialNetwork.provider,
          this.liveSocialState.providers[providerKey],
        ] as ViewLiveSocial.ProvidersEntries;
      })
        .filter((provider) => provider[1]?.length)
        .map((accounts) => {
          const provider = accounts[0];

          return accounts[1].map((_, index) => ({ provider, indexProvider: index }));
        })
        .flat();
    },
    eventsState(): Store.Events.State {
      return this.events;
    },
    eventState(): Store.Events.Event | undefined {
      return this.eventsState.event;
    },
    isThereLiveActive(): boolean {
      return this.haveAllCardsBeenMounted && !!this.activeServices.length;
    },
    liveDescription(): string {
      return this.liveSocialState.general.description;
    },
    liveOrOnDemand(): 'liveData' | 'odData' {
      return this.eventState?.liveData ? 'liveData' : 'odData';
    },
    liveSocialState(): Store.LiveSocial.State {
      return this.liveSocial;
    },
    liveTitle(): string {
      return this.liveSocialState.general.title;
    },
    numberOfSelectedServices(): number {
      return this.selectedServices.length;
    },
    selectedServices(): Store.LiveSocial.LiveSocialNetwork[] {
      return this.createdServices.filter((service: Store.LiveSocial.LiveSocialNetwork) => (
        service.selected
      ));
    },
    userState(): Store.User.State {
      return this.user;
    },
    youtubeLivestreamSettings(): Store.LiveSocial.YoutubeLivestreamUserSettings {
      return this.liveSocial.youtubeLivestreamUserSettings;
    },
  },

  watch: {
    showModal(): void {
      if (!this.showModal.custom || !this.showModal.twitch) {
        this.customServiceName = '';
        this.streamServiceAccessKey = '';
        this.streamServiceUrl = '';
        this.twitchLiveModalForm = {
          name: '',
          streamUrl: '',
          streamKey: '',
        };
        this.isUpdatingService = false;
        this.serviceToBeEdited = null;
      }
    },
    modalCreateLiveSocial(): void {
      this.madeForKids = this.liveSocialState.general.madeForKids || false;
      this.selectedPrivacyStatus = this.liveSocialState.general.privacyStatus || '';
      this.typedDescription = this.liveDescription || '';
      this.typedTitle = this.liveTitle || '';
    },
    modalStartStopBroadcast(): void {
      if (!this.modalStartStopBroadcast && !this.hasModalStartStopBroadcastBeenConfirmed) {
        this.checkOrUncheckServices(
          this.lastSelectedService.selected ? 'uncheck' : 'check',
          'last',
        );

        this.hasModalStartStopBroadcastBeenCancelled = true;
        this.modalStartStopBroadcast = false;
      }

      this.hasModalStartStopBroadcastBeenConfirmed = false;
    },
    numberOfSelectedServices(): void {
      this.selectAll = this.numberOfSelectedServices === this.createdServices.length;

      if (this.numberOfSelectedServices > this.simultaneousLivesLimit) {
        this.watchChanges(() => { this.checkOrUncheckServices('uncheck', 'last'); });

        this.isMaxNumberOfSelectedServices = true;
        this.warningMessage = 'maximum_number_of_selected_services';
        this.warningModal = true;

        return;
      }

      if (
        this.isMaxNumberOfSelectedServices
        && this.numberOfSelectedServices < this.simultaneousLivesLimit
      ) {
        this.isMaxNumberOfSelectedServices = false;
      }

      if (
        this.isThereLiveActive
        && !this.isMaxNumberOfSelectedServices
        && !this.hasModalStartStopBroadcastBeenCancelled
      ) {
        const isLiveActiveOnThisService = this.lastSelectedService.status === 1;

        this.broadcastModalMessage = isLiveActiveOnThisService
          ? 'stop'
          : 'start';
        this.modalStartStopBroadcast = true;

        return;
      }

      this.hasModalStartStopBroadcastBeenCancelled = false;
    },
  },

  async mounted() {
    const response = await this.fetchBroadcastData();

    if (response === 'error') {
      this.$router.push({
        name: 'Error',
        params: {
          error: '404',
          title: 'event_not_found',
          message: 'back_events_page',
        },
      });

      return;
    }

    await this.getCustomerPlan(this.eventState?.customer_plans_lvw_id || -1)
      .then((data) => {
        this.customerPlanData = data;

        this.simultaneousLivesLimit = this.customerPlanData.total_push_social;
      });

    this.loadLiveSocialGeneral({
      customer_plans_id: this.userState.planId,
      customer_plans_events_id: this.eventState?.id,
    } as Services.LiveSocial.GetLiveSocialGeneral)
      .then(() => {
        const haveLiveSocialGeneral = !!this.liveTitle
          && !!this.liveDescription
          && !!this.liveSocialState.general.privacyStatus;

        this.modalCreateLiveSocial = !haveLiveSocialGeneral;
      });

    const promises = [] as Promise<void>[];

    this.socialNetworks.forEach(({ provider }) => {
      // Store.LiveSocial.LiveSocialNetwork[]
      if (['custom', 'twitch'].includes(provider)) {
        promises.push(this.loadServices({
          event_id: this.eventState?.id,
          plan_id: this.userState.planId,
          provider,
        } as Services.LiveSocial.GetServices));

        return;
      }

      // Store.LiveSocial.UserSocialNetwork[]
      promises.push(this.loadUserAccounts({
        customerPlansEventsId: this.eventState?.id,
        customerPlansId: this.userState.planId,
        provider,
      } as Services.LiveSocial.GetUserAccounts));
    });

    Promise.all(promises).then(() => {
      this.haveAllCardsBeenMounted = true;

      if (this.createdServices.length) {
        this.selectAll = this.numberOfSelectedServices === this.createdServices.length;
      }
    });
  },

  methods: {
    ...mapActions({
      createService: 'liveSocial/createService',
      createWowzaTarget: 'liveSocial/createWowzaTarget',
      deleteWowzaTarget: 'liveSocial/deleteWowzaTarget',
      loadEvent: 'events/loadEvent',
      loadEvents: 'events/loadEvents',
      loadLiveSocialGeneral: 'liveSocial/loadLiveSocialGeneral',
      loadServices: 'liveSocial/loadServices',
      loadUserAccounts: 'liveSocial/loadUserAccounts',
      saveLiveSocialGeneral: 'liveSocial/saveLiveSocialGeneral',
      startOrEndLive: 'events/startOrEndLive',
      updateLiveSocialGeneral: 'liveSocial/updateLiveSocialGeneral',
      bindBroadcastToStream: 'liveSocial/youtubeBindBroadcastToStream',
      facebookChangeWowzaTarget: 'liveSocial/facebookChangeStreamTarget',
      youtubeChangeStreamTarget: 'liveSocial/youtubeChangeStreamTarget',
      youtubeCreateStreamTarget: 'liveSocial/youtubeCreateStreamTarget',
      youtubeRemoveStreamTarget: 'liveSocial/youtubeRemoveStreamTarget',
    }),
    ...mapMutations('liveSocial', ['setSelectedServices']),
    removeThisOnClickLater(): void {
      this.socialNetworks[1].disabled = undefined;
    },
    async addWowzaTarget(service: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      const server = this.customerPlanData.server_ip || 'server';
      const targetSettings = this.getTargetSettings(service.provider_settings.streaming_url);

      const liveEvent = this.eventState;
      let targetData: Services.LiveSocial.PostWowzaTarget;

      if (targetSettings && liveEvent?.stream && this.eventsState.secret) {
        switch (this.customerPlanData.type_plans) {
          default:
            targetData = {
              application: `LVW-${liveEvent.customer_plans_lvw_id}`,
              destination_application: targetSettings.destinationApplication,
              destination_host: targetSettings.destinationHost,
              destination_port: targetSettings.destinationPort,
              destination_stream_name: service.provider_settings.streaming_key,
              destination_use_ssl: targetSettings.destinationUseSsl,
              entryName: this.setTargetName({
                customerPlanName: `EVT-${liveEvent.customer_plans_id}`,
                provider: service.provider,
                streamType: service.stream_type,
                transmissionId: service.transmission_id,
              }),
              secret: this.eventsState.secret,
              server,
              sourceStreamName: liveEvent.stream,
              stream: liveEvent.stream,
            };
            break;
        }

        return this.createWowzaTarget(targetData);
      }

      return Promise.reject();
    },
    async addYoutubeWowzaTarget(
      service: Store.LiveSocial.LiveSocialNetwork,
    ): Promise<Services.LiveSocial.Youtube.CreateWowzaTarget> {
      const targetSettings = this.getTargetSettings(service.provider_settings.streaming_url);

      const liveEvent = this.eventState;
      let targetData: Services.LiveSocial.Youtube.CreateWowzaTarget;

      if (targetSettings && liveEvent?.stream && this.eventsState.secret) {
        switch (this.customerPlanData.type_plans) {
          default:
            targetData = {
              application: `LVW-${liveEvent.customer_plans_lvw_id}`,
              sourceStreamName: liveEvent.stream,
              entryName: this.setTargetName({
                customerPlanName: `EVT-${liveEvent.customer_plans_id}`,
                provider: service.provider,
                streamType: service.stream_type,
                transmissionId: service.transmission_id,
              }),
              destination_application: targetSettings.destinationApplication,
              destination_host: targetSettings.destinationHost,
              destination_port: targetSettings.destinationPort,
              destination_stream_name: service.provider_settings.streaming_key,
              destination_use_ssl: targetSettings.destinationUseSsl,
            };
            break;
        }

        await this.youtubeCreateStreamTarget(targetData);
        return targetData;
      }

      return Promise.reject();
    },
    assembleProviderSettings(
      stream: Services.LiveSocial.Facebook.Response.PostLive,
    ): Store.LiveSocial.ProviderSettings {
      const splitUrl = stream.stream_url.split('/');
      const streamUrlSecure = stream.secure_stream_url.split('/')[2];

      return {
        streaming_id: stream.id,
        streaming_key: splitUrl[4],
        streaming_secure_url: `rtmps://${streamUrlSecure}/rtmp`,
        streaming_url: `rtmp://${splitUrl[2]}/rtmp`,
      };
    },
    checkOrUncheckServices(
      duty: 'check' | 'uncheck',
      service: 'all' | 'last' | Store.LiveSocial.LiveSocialNetwork,
    ): void {
      let providers: Store.LiveSocial.Provider[];
      let servicesIds: string[];

      switch (service) {
        case 'all':
          providers = this.createdServices.map(
            (createdService: Store.LiveSocial.LiveSocialNetwork) => createdService.provider,
          );
          servicesIds = this.createdServices.map(
            (createdService: Store.LiveSocial.LiveSocialNetwork) => createdService.id,
          );
          break;
        case 'last':
          providers = [this.lastSelectedService.provider];
          servicesIds = [this.lastSelectedService.id];
          break;
        default:
          providers = [service.provider];
          servicesIds = [service.id];
          break;
      }

      this.setSelectedServices({
        providers,
        select: duty === 'check',
        servicesIds,
      } as Store.LiveSocial.Mutations.SetSelectedServices);
    },
    async createOrUpdateFacebookStream(
      service: Store.LiveSocial.LiveSocialNetwork,
    ): Promise<false | Store.LiveSocial.LiveSocialNetwork> {
      const pageId = service.transmission_type === 'page' ? service.transmission_id : undefined;
      const userId = this.getFacebookAccount(service).user_id;

      const createAndUpdateFacebookService = async () => {
        const newStream = await this.facebookCreateService({
          description: service.description,
          page_id: pageId,
          stream_type: service.stream_type,
          title: service.title,
          user_id: userId,
        });

        const providerSettings = this.assembleProviderSettings(newStream);

        const payload = {
          ...service,
          provider_settings: providerSettings,
        } as Store.LiveSocial.LiveSocialNetwork;

        await this.updateService(payload);

        return payload;
      };

      try {
        const stream = await this.facebookFindLive({
          live_id: service.provider_settings.streaming_id,
          page_id: pageId,
          user_id: userId,
        });

        if (stream.status !== 'UNPUBLISHED' && stream.status !== 'LIVE') {
          return createAndUpdateFacebookService();
        }

        await this.facebookUpdateService(service);

        return false;
      } catch (e) {
        const error = e as ViewLiveSocial.FacebookError;
        // if facebook error code is 100 and error sub code is 33
        // This live do not exist anymore, so re-created
        if (
          error.status === 400
          || (error.data.error.code === 100 && error.data.error.error_subcode === 33)
        ) {
          // create a new page stream
          return createAndUpdateFacebookService();
        }

        return false;
      }
    },
    editService(): void {
      const service = this.serviceToBeEdited as Store.LiveSocial.LiveSocialNetwork;

      this.isUpdatingService = true;

      switch (service.provider) {
        case 'custom':
          this.customServiceName = service.name;
          this.streamServiceAccessKey = service.provider_settings.streaming_key;
          this.streamServiceUrl = service.provider_settings.streaming_url;
          this.showModal.custom = true;
          break;
        case 'twitch':
          this.twitchLiveModalForm.name = service.name;
          this.twitchLiveModalForm.streamKey = service.provider_settings.streaming_key;
          this.twitchLiveModalForm.streamUrl = service.provider_settings.streaming_url;
          this.showModal.twitch = true;
          break;
        default: break;
      }
    },
    facebookCreateService(
      payload: Services.LiveSocial.Facebook.PostLive,
    ): Promise<Services.LiveSocial.Facebook.Response.PostLive> {
      return this.$store.dispatch('liveSocial/facebookCreateService', payload);
    },
    facebookFindLive(
      payload: Services.LiveSocial.Facebook.GetLive,
    ): Promise<Services.LiveSocial.Facebook.Response.GetLive> {
      return this.$store.dispatch('liveSocial/facebookFindLive', payload);
    },
    facebookUpdateService(
      service: Store.LiveSocial.LiveSocialNetwork,
      afterFinishingLive?: true,
    ): Promise<void> {
      const pageId = service.transmission_type === 'page'
        ? service.transmission_id
        : undefined;
      const userId = this.getFacebookAccount(service).user_id;

      return this.$store.dispatch('liveSocial/facebookUpdateService', {
        description: service.description,
        end_live_video: afterFinishingLive,
        live_id: service.provider_settings.streaming_id,
        page_id: pageId,
        title: service.title,
        user_id: userId,
      } as Services.LiveSocial.Facebook.PutLive);
    },
    async fetchBroadcastData(): Promise<void | 'error'> {
      if (!this.eventsState.secret) {
        await this.loadEvents({
          planId: parseInt(this.userState.planId, 10),
        } as Services.Events.GetEvents);
      }

      if (!this.eventState?.liveData) {
        return this.loadEvent({
          planId: parseInt(this.userState.planId, 10),
          hash: this.hash,
        } as Services.Events.GetEvent);
      }

      return Promise.resolve();
    },
    getCustomerPlan(
      planId: number | string,
    ): Promise<Services.User.Response.CustomerPlan> {
      return this.$store.dispatch('user/getCustomerPlan', planId);
    },
    getTargetSettings(streamingUrl: string): ViewLiveSocial.TargetSettings | null {
      const regex = /^(rtmps|rtmp)?(:\/\/)?([a-z]*-*[a-z-a-z.a-z*.a-z]*)?(:)?([0-9]*)?(\/)?([a-z0-9]*)/i;

      const config = regex.exec(streamingUrl);

      return config
        ? {
          destinationApplication: config[7],
          destinationHost: config[3],
          destinationPort: config[5] || '1935',
          destinationUseSsl: config[5] && config[5] === '443' ? 'true' : 'false',
        }
        : null;
    },
    getFacebookAccount(
      service: Store.LiveSocial.LiveSocialNetwork,
    ): Store.LiveSocial.UserSocialNetwork {
      let accountIndex = -1;

      this.liveSocialState.providers.facebook.forEach((facebookAccount, index) => {
        if (facebookAccount.lives) {
          facebookAccount.lives.forEach((serviceAccount) => {
            if (serviceAccount.id === service.id) {
              accountIndex = index;
            }
          });
        }
      });

      return this.liveSocialState.providers.facebook[accountIndex];
    },
    async onClickConfirmModalStartStopBroadcast(): Promise<void> {
      this.isModalStartStopBroadcastButtonLoading = true;

      if (this.lastSelectedService.status === 0) {
        await this.startLiveSocial(this.lastSelectedService)
          .then(() => this.showNotification('live_started', 'success'))
          .catch(() => { /* CATCH colocado apenas para não travar o fluxo aqui */ });
      } else {
        await this.stopLiveSocial(this.lastSelectedService)
          .then(() => this.showNotification('live_ended', 'success'))
          .catch(() => this.checkOrUncheckServices('check', 'last'));
      }

      this.isModalStartStopBroadcastButtonLoading = false;
      this.hasModalStartStopBroadcastBeenConfirmed = true;
      this.modalStartStopBroadcast = false;
    },
    async onClickSaveLiveSocialGeneral(): Promise<void> {
      this.isSaveLiveSocialGeneralButtonLoading = true;

      const alreadyHaveLiveSocialGeneral = !!this.liveTitle
        && !!this.liveDescription
        && !!this.liveSocialState.general.privacyStatus;
      if (alreadyHaveLiveSocialGeneral) {
        await this.updateLiveSocialGeneral({
          description: this.typedDescription.trim(),
          id: this.liveSocialState.general.id,
          madeForKids: this.madeForKids,
          privacyStatus: this.selectedPrivacyStatus,
          title: this.typedTitle.trim(),
        } as Services.LiveSocial.PutLiveSocialGeneral);
      } else {
        await this.saveLiveSocialGeneral({
          customer_plans_events_id: this.eventState?.id,
          customer_plans_id: this.userState.planId,
          description: this.typedDescription.trim(),
          madeForKids: this.madeForKids,
          privacyStatus: this.selectedPrivacyStatus,
          title: this.typedTitle.trim(),
        } as Services.LiveSocial.PostLiveSocialGeneral);
      }

      this.isSaveLiveSocialGeneralButtonLoading = false;

      if (this.liveTitle && this.liveDescription) {
        this.modalCreateLiveSocial = false;
      }
    },
    onClickSelectAll(): void {
      this.selectAll = !this.selectAll;

      if (!this.selectAll || (this.createdServices.length <= this.simultaneousLivesLimit)) {
        const duty = this.selectAll ? 'check' : 'uncheck';

        this.checkOrUncheckServices(duty, 'all');

        return;
      }

      this.warningMessage = 'maximum_number_of_selected_services';
      this.warningModal = true;
      this.watchChanges(() => { this.selectAll = !this.selectAll; });
    },
    async onClickStartOrStopRetransmission(): Promise<void> {
      this.isStartStopRetransmissionButtonLoading = true;

      if (!this.isThereLiveActive) {
        if (!this.isThereAtLeastOneBroadcastingWay) {
          this.isStartStopRetransmissionButtonLoading = false;
          this.warningMessage = 'link_social_network_account';
          this.warningModal = true;
          return;
        }

        if (!this.numberOfSelectedServices) {
          this.isStartStopRetransmissionButtonLoading = false;
          this.warningMessage = 'select_broadcasting_way';
          this.warningModal = true;
          return;
        }

        await this.startLiveSocial()
          .then(() => this.showNotification('live_started', 'success'))
          .catch(() => { /* CATCH colocado apenas para não travar o fluxo aqui */ });
      } else {
        await this.stopLiveSocial()
          .then(() => {
            this.checkOrUncheckServices('uncheck', 'all');
            this.showNotification('live_ended', 'success');
          })
          .catch((servicesStoppedSuccessfully: Store.LiveSocial.LiveSocialNetwork[]) => {
            servicesStoppedSuccessfully.forEach((service) => {
              this.checkOrUncheckServices('uncheck', service);
            });
          });
      }

      this.isStartStopRetransmissionButtonLoading = false;
    },
    async removeWowzaTarget(service: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      await this.deleteWowzaTarget({
        application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
        server: this.customerPlanData.server_ip || 'server',
        streamtargetname: service.process_name,
      } as Services.LiveSocial.DeleteWowzaTarget);
    },
    async removeYotubeWowzaTarget(service: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      await this.youtubeRemoveStreamTarget({
        application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
        streamtargetname: service.process_name,
      } as Services.LiveSocial.Youtube.RemoveWowzaTarget);
    },
    async saveOrUpdateCustomAccount(): Promise<void> {
      this.isSaveOrUpdateCustomAccountButtonLoading = true;

      const providerSettings = {
        streaming_id: this.streamServiceAccessKey,
        streaming_key: this.streamServiceAccessKey,
        streaming_secure_url: '',
        streaming_url: this.streamServiceUrl,
      } as Store.LiveSocial.ProviderSettings;

      if (this.isUpdatingService) {
        await this.updateService({
          ...this.serviceToBeEdited as Store.LiveSocial.LiveSocialNetwork,
          description: this.liveDescription,
          name: this.customServiceName,
          provider_settings: providerSettings,
          title: this.liveTitle,
          transmission_id: this.streamServiceAccessKey,
        });
      } else {
        await this.createService({
          description: this.liveDescription,
          id_customer_plans: parseInt(this.userState.planId, 10),
          id_customer_plans_events: this.eventState?.id,
          name: this.customServiceName,
          provider: 'custom',
          provider_settings: JSON.stringify(providerSettings),
          stream_type: 'NORMAL',
          title: this.liveTitle,
          transmission_id: this.streamServiceAccessKey,
          transmission_type: 'custom',
        } as Services.LiveSocial.PostService);
      }

      this.isSaveOrUpdateCustomAccountButtonLoading = false;
      this.showModal.custom = false;
    },
    async saveOrUpdateTwitchLive(): Promise<void> {
      this.isSaveOrUpdateTwitchLiveLoading = true;

      const providerSettings = {
        streaming_id: this.twitchLiveModalForm.streamKey,
        streaming_key: this.twitchLiveModalForm.streamKey,
        streaming_secure_url: '',
        streaming_url: this.twitchLiveModalForm.streamUrl,
      } as Store.LiveSocial.ProviderSettings;

      if (this.isUpdatingService) {
        await this.updateService({
          ...this.serviceToBeEdited as Store.LiveSocial.LiveSocialNetwork,
          description: this.liveDescription,
          name: this.twitchLiveModalForm.name,
          provider_settings: providerSettings,
          title: this.liveTitle,
          transmission_id: this.twitchLiveModalForm.streamKey,
        });
      } else {
        await this.createService({
          description: this.liveDescription,
          id_customer_plans: parseInt(this.userState.planId, 10),
          id_customer_plans_events: this.eventState?.id,
          name: this.twitchLiveModalForm.name,
          provider: 'twitch',
          provider_settings: JSON.stringify(providerSettings),
          stream_type: 'NORMAL',
          title: this.liveTitle,
          transmission_id: this.twitchLiveModalForm.streamKey,
          transmission_type: 'custom',
        } as Services.LiveSocial.PostService);
      }

      this.isSaveOrUpdateTwitchLiveLoading = false;
      this.showModal.twitch = false;
    },
    setTargetName(data: ViewLiveSocial.SetTargetName): string {
      const {
        customerPlanName,
        provider,
        streamType,
        transmissionId,
      } = data;

      const providers = {
        custom: 'OT', // OT = others
        facebook: 'FB',
        instagram: 'IT',
        twitch: 'TC',
        twitter: 'TW',
        youtube: 'YT',
      };

      return `${providers[provider]}-${streamType}-${customerPlanName}-${transmissionId}`;
    },
    showNotification(text: string, type: 'error' | 'success'): void {
      this.$store.dispatch('notification/create', { text, type });
    },
    async startLiveSocial(service?: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      const services = service ? [service] : this.selectedServices;
      const promises = [] as Promise<void>[];
      let errorHasOccurred = false;
      let newService: false | Store.LiveSocial.LiveSocialNetwork = false;

      const startLiveFullProcess = async (
        currentService: Store.LiveSocial.LiveSocialNetwork,
      ) => {
        if (currentService.provider === 'facebook') {
          newService = await this.createOrUpdateFacebookStream(currentService);
          const finalService = newService || currentService;
          console.log('Trying to start facebook stream...');
          await this.facebookChangeWowzaTarget({
            application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
            streamtargetname: finalService.process_name,
            action: 'enable',
          } as Services.LiveSocial.Facebook.ChangeWowzaTarget);
        } else if (currentService.provider === 'youtube') {
          newService = await this.createYoutubeLiveSocial(currentService);
          const finalService = newService || currentService;
          console.log('Trying to start youtube stream...', finalService);
          const target = await this.addYoutubeWowzaTarget(finalService);
          await this.youtubeChangeStreamTarget({
            application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
            streamtargetname: target.entryName,
            action: 'enable',
          } as Services.LiveSocial.Youtube.ChangeWowzaTarget);
        }

        const finalService = newService || currentService;
        console.log('The creation of wowza taraget: ', finalService);
        return this.updateService(finalService, 'afterStartingLive');
      };
      services.forEach((currentService) => {
        promises.push(
          startLiveFullProcess(currentService)
            .catch(() => {
              errorHasOccurred = true;
              this.checkOrUncheckServices('uncheck', currentService);
              this.showNotification(`
                ${this.$t('there_was_an_error_starting_live')}
                ${this.$t(currentService.transmission_type)}: ${currentService.name}
              `, 'error');
            }),
        );
      });

      await Promise.all(promises);

      if (errorHasOccurred) throw new Error();
    },
    async stopLiveSocial(service?: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      const services = service ? [service] : this.activeServices;
      const servicesStoppedSuccessfully = [] as Store.LiveSocial.LiveSocialNetwork[];
      const promises = [] as Promise<void>[];
      let errorHasOccurred = false;

      const stopLiveFullProcess = async (
        currentService: Store.LiveSocial.LiveSocialNetwork,
      ) => {
        if (currentService.provider === 'facebook') {
          console.log('Trying to stop facebook stream...');
          await this.facebookUpdateService(currentService, true);
          await this.facebookChangeWowzaTarget({
            application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
            streamtargetname: currentService.process_name,
            action: 'disable',
          } as Services.LiveSocial.Facebook.ChangeWowzaTarget);
        } else if (currentService.provider === 'youtube') {
          console.log('Trying to stop youtube stream...');
          await this.youtubeChangeStreamTarget({
            application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
            streamtargetname: currentService.process_name,
            action: 'disable',
          } as Services.LiveSocial.Youtube.ChangeWowzaTarget);
          this.removeYotubeWowzaTarget(currentService);
        }

        return this.updateService(currentService, 'afterFinishingLive');
      };

      services.forEach((currentService) => {
        promises.push(
          stopLiveFullProcess(currentService)
            .then(() => { servicesStoppedSuccessfully.push(currentService); })
            .catch(() => {
              errorHasOccurred = true;
              this.showNotification(`
                ${this.$t('there_was_an_error_ending_live')}
                ${this.$t(currentService.transmission_type)}: ${currentService.name}
              `, 'error');
            }),
        );
      });

      await Promise.all(promises);

      if (errorHasOccurred) throw servicesStoppedSuccessfully;
    },
    updateService(
      service: Store.LiveSocial.LiveSocialNetwork,
      after?: 'afterStartingLive' | 'afterFinishingLive',
    ): Promise<void> {
      let payload = service;

      if (after) {
        payload = after === 'afterStartingLive'
          ? {
            ...service,
            process_id: parseInt(service.id, 10),
            process_name: this.setTargetName({
              customerPlanName: `EVT-${this.eventState?.customer_plans_id}`,
              provider: service.provider,
              streamType: service.stream_type,
              transmissionId: service.transmission_id,
            }),
            status: 1,
          }
          : { ...service, status: 0 };
      }

      return this.$store.dispatch('liveSocial/updateService', payload);
    },
    /**
     * Timeout de `200ms` utilizado para o componente ficar reativo.
     * Onde irá observar a mudança que é feita quase que instantaneamente.
     */
    watchChanges(callback: Function): NodeJS.Timeout {
      return setTimeout(() => callback(), 200);
    },
    showLiveModal(modalToShow: string): void {
      if (modalToShow === 'custom') {
        this.showModal.custom = true;
      } else if (modalToShow === 'twitch') {
        this.showModal.twitch = true;
      } else if (modalToShow === 'instagram') {
        this.showModal.instagram = true;
      }
    },
    async createYoutubeLiveBroadcast(
      payload: Services.LiveSocial.Youtube.PostLiveBroadcast,
    ): Promise<Services.LiveSocial.Youtube.Response.PostLiveBroadcastResponse> {
      return this.$store.dispatch('liveSocial/youtubeCreateLiveBroadcast', payload);
    },
    async createYoutubeLiveStream(
      payload: Services.LiveSocial.Youtube.PostLiveStream,
    ): Promise<Services.LiveSocial.Youtube.Response.PostLiveStreamResponse> {
      return this.$store.dispatch('liveSocial/youtubeCreateLiveStream', payload);
    },
    // update youtube live social when is from modal
    async updateYoutubeStream(): Promise<void> {
      if (this.isUpdatingService) {
        await this.updateService({
          ...this.serviceToBeEdited as Store.LiveSocial.LiveSocialNetwork,
          title: 'new title from modal',
          description: 'new desc from modal',
        });
      }
    },
    // create youtube live on youtube api and update live social
    async createYoutubeLiveSocial(
      service: Store.LiveSocial.LiveSocialNetwork,
    ): Promise<Store.LiveSocial.LiveSocialNetwork> {
      const scheduledStartTime = new Date();
      const scheduledEndTime = new Date(
        new Date().setHours(scheduledStartTime.getHours() + 1),
      );

      const {
        description, title,
      } = this.liveSocialState.general;

      const userId = this.liveSocialState.providers.youtube[0].user_id;

      const liveBroadcast = await this.createYoutubeLiveBroadcast({
        title,
        description,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        scheduledEndTime,
        scheduledStartTime,
        selfDeclaredMadeForKids: this.madeForKids,
        status: this.selectedPrivacyStatus,
        user_id: userId,
      });

      const liveStream = await this.createYoutubeLiveStream({
        frameRate: '30fps',
        ingestionType: 'rtmp',
        part: ['cdn', 'id', 'snippet', 'status'],
        resolution: '1080p',
        title,
        user_id: userId,
      });

      await this.bindBroadcastToStream({
        id: liveBroadcast.id,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        streamId: liveStream.id,
        user_id: userId,
      } as Services.LiveSocial.Youtube.PostBindBroadcastToStream);

      const providerSettings = {
        streaming_id: liveBroadcast.id,
        streaming_key: liveStream.cdn.ingestionInfo?.streamName,
        streaming_secure_url: '',
        streaming_url: liveStream.cdn.ingestionInfo?.ingestionAddress,
      } as Store.LiveSocial.ProviderSettings;

      const newService = {
        ...service,
        provider_settings: providerSettings,
        transmission_id: liveBroadcast.id,
      };

      return newService;
    },
  },
});
